import React from 'react';
import { Skeleton } from 'twain-sport-fe-mono';
import classes from './Skeletons.scss';

export const ListSkeleton: React.FC = () => (
    <>
        {[1, 2, 3].map((index) => (
            <Skeleton key={index} className={classes.skeleton} />
        ))}
    </>
);
